export const brazeBaseUrl = 'sdk.fra-02.braze.eu';
export const brazeLoadScriptSrc =
  'https://areena.ylestatic.fi/static/js/braze/5.7/braze.js';
